export default __webpack_public_path__ + "static/media/iz-ru-logo.1b2fc3a0.svg";